import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import {} from '@fortawesome/react-fontawesome'

import 'typeface-montserrat'
import 'typeface-merriweather'
import './src/normalize.css'
import './src/style.css'
import './src/datepicker.css'

import { applyBlogAttributionFromSearch, isOfferteFlowPath } from './src/helpers/blogAttribution'

export { wrapRootElement } from './gatsby-shared'

library.add(fas)

export const onRouteUpdate = ({ location }) => {
	if (typeof window === 'undefined' || !location) return
	if (isOfferteFlowPath(location.pathname)) {
		applyBlogAttributionFromSearch(location)
	}
}

export const onInitialClientRender = () => {
	if (typeof window !== 'undefined') {
		const urlParams = new URLSearchParams(window.location.search)
		const gclid = urlParams.get('gclid')

		if (gclid) {
			localStorage.setItem('gclid', gclid)
		}

		if (isOfferteFlowPath(window.location.pathname)) {
			applyBlogAttributionFromSearch(window.location)
		}
	}
}
